<div class="title">
    <div class="row">
        <div class="col d-flex justify-content-end">
            <button type="button" class="action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col d-flex justify-content-center">
            <h2>Nume pre-înrolat: {{preInrolat.nume + " " + preInrolat.prenume}}</h2>
        </div>
    </div>
</div>
<div class="container">
    <div class="info-card">
        <div class="info-header">
            <mat-icon>info</mat-icon>
            <span class="info-title">Info pre-înrolat</span>
        </div>
        <div class="info-content">
            <div class="info-row">
                <label>Nume:</label>
                <span>{{preInrolat.nume}}</span>
            </div>
            <div class="info-row">
                <label>Prenume:</label>
                <span>{{preInrolat.prenume}}</span>
            </div>
            <div class="info-row">
                <label>CNP:</label>
                <span>{{preInrolat.cnp}}</span>
            </div>
            <div class="info-row">
                <label>Pin:</label>
                <span>{{preInrolat.pin}}</span>
            </div>
            <div class="info-row">
                <label>Email:</label>
                <span>{{preInrolat.email}}</span>
            </div>
            <div class="info-row">
                <label>Telefon:</label>
                <span>{{preInrolat.telefon}}</span>
            </div>
            <div class="info-row">
                <label>CUI:</label>
                <span>{{preInrolat.cui}}</span>
            </div>
            <div class="info-row">
                <label>Nume firmă:</label>
                <span>{{preInrolat.f_nume}}</span>
            </div>
            <div class="info-row">
                <label>Nr. în registrul comerțului:</label>
                <span>{{preInrolat.f_reg_com}}</span>
            </div>
            <div class="info-row">
                <label>Creat la:</label>
                <span>{{preInrolat.created_at | date:'dd.MM.yyyy HH:mm' }}</span>
            </div>
            <div class="info-row">
                <label>Actualizat la:</label>
                <span>{{preInrolat.updated_at | date:'dd.MM.yyyy HH:mm' }}</span>
            </div>
        </div>
    </div>

    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
</div>